import React from 'react';

import moment from 'moment/moment';

import {
  ColumnProps,
  TableHeaderFunction,
} from 'components/WrappedComponents/Table/types';
import { profileEnumMapping } from 'utils/enumData';
import { DATE_FORMAT } from 'utils/formats';

import SupervisionHeader from '../SupervisionHeader/SupervisionHeader';
import { SupervisionUserEventsFilterFormValues } from '../SupervisionHeader/types';
import { userEventOperationsMapping } from '../utils';

import { SortOptions } from './useSearchUserEventsDto';

export interface UtilisateursResponseDto {
  id: string;
  dateRealisation: string;
  typeAction: string;
  role: string;
  entiteRattachement: string;
}

export const buildColumns = (): ColumnProps<
  UtilisateursResponseDto,
  SortOptions
>[] => {
  return [
    {
      title: 'Date de réalisation',
      sortedField: SortOptions.DATE_REALISATION,
      buildCellContent: data =>
        moment(data.dateRealisation).format(DATE_FORMAT),
    },
    {
      title: "Type d'action",
      sortedField: SortOptions.TYPE_ACTION,
      buildCellContent: data =>
        userEventOperationsMapping[
          data.typeAction as keyof typeof userEventOperationsMapping
        ],
    },
    {
      title: 'Profil',
      buildCellContent: data =>
        data.role
          ? profileEnumMapping[data.role as keyof typeof profileEnumMapping]
              .name
          : '',
    },
    {
      title: 'Entité de rattachement',
      buildCellContent: data => data.entiteRattachement,
    },
  ];
};

export const buildHeader: TableHeaderFunction<
  UtilisateursResponseDto,
  SupervisionUserEventsFilterFormValues
> = (fetchedData, _selectedData, filter, setFilter, sort) => (
  <SupervisionHeader
    totalResult={fetchedData !== undefined ? fetchedData.total : 0}
    filter={filter}
    setFilter={setFilter}
    sort={sort}
  />
);
